// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5WN50","field":"styles_field__1dhx_","fieldCol":"styles_fieldCol__DF2NI","diffCol":"styles_diffCol__hT2Kz","diff":"styles_diff__2rh2P"};